import { render, staticRenderFns } from "./MyPayments.vue?vue&type=template&id=b06f3e8c&scoped=true"
import script from "./MyPayments.vue?vue&type=script&lang=js"
export * from "./MyPayments.vue?vue&type=script&lang=js"
import style0 from "./MyPayments.vue?vue&type=style&index=0&id=b06f3e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06f3e8c",
  null
  
)

export default component.exports